module.exports = __webpack_public_path__ + "static/img/active-shipping-credit.5c08992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/active-shipping-credit.png
// module id = IPSm
// module chunks = 150